import { useContext } from "react";

import { DarkModeContext } from "./darkModeContext";

export function useDarkMode() {
  const ctx = useContext(DarkModeContext);
  if (!ctx) {
    throw new Error("useDarkMode must be used inside <DarkModeProvider>");
  }
  return ctx;
}
